<div class="upload-file mt-5">
  <ngx-file-drop dropZoneLabel="Drop files here" (onFileDrop)="fileDropped($event)" multiple="false"
    dropZoneLabel="Drag & Drop File">
    <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
      <a class="pick-file" (click)="openFileSelector()">
        <div class="d-block">
          <div class="text-center">Drag & Drop File here</div>
          <div class="text-center">Or Pick by Clicking</div>
        </div>
      </a>
    </ng-template>
  </ngx-file-drop>
</div>

<div class="py-2"> 
<app-progress *ngIf="isUpload" [progress]="uploadProgress"></app-progress>
</div>
<crm-alert #alert></crm-alert>

<div class="d-flex justify-content-between align-items-center py-4">
<nav *ngIf="allFiles.length > 0">
  <ol class="breadcrumb mb-0">
    <li class="breadcrumb-item" (click)="goRoot()"><a href="javascript: void(0);">{{rootFolder.NAME}}</a> <span
        class="ml-2">{{getFileCount()}}</span></li>
    <li class="breadcrumb-item" *ngFor="let nav of childNav; let i = index;"
      [ngClass]="{'active': (childNav.length - 1) == i}">
      <ng-container *ngIf="(childNav.length - 1) == i else link">
        {{nav.NAME}}
      </ng-container>

      <ng-template #link>
        <a href="javascript:void(0);" (click)="onNavLinkClick(nav, i)">{{nav.NAME}}</a>
      </ng-template>
    </li>
  </ol>
</nav>

<div class="d-flex align-items-center ml-auto">
  <div class="menu__item  mr-3" *ngIf="fileSelected() > 1" (click)="deleteAll()">
    <i class="fa fa-trash mr-2"  style="color: #337ab7;"></i>
    <span>Delete All</span>
  </div>

  <div class="menu__item mr-3" *ngIf="fileSelected() > 1" (click)="downloadZip()">
    <i class="fa fa-download mr-2" style="color: #337ab7;"></i>
    <span>Download</span>
  </div>

  <button  type="button" class="btn btn-rbv hinted ng-star-inserted" (click)="createFolder()">
    <i class="fa fa-folder" style="width: 20px;color: #ffae00;"></i>
     Add New Folder </button>
</div>
</div>

<loader [loading]="isLoading"></loader>

<div class="empty-container" *ngIf="!isLoading && allFiles.length == 0; else notEmpty">
  <p style="font-size: 20px; font-weight: bold;">Create folder first to upload file</p>
  <button class="btn btn-rbv" (click)="createFolder()">Create Folder</button>
</div>

<ng-template #notEmpty>
  <div class="file-container" *ngIf="!isLoading">
    <div class="header-field">
      <div class="column check mr-3">
        <label class="checkbox mb-0">
          <input type="checkbox" class="checkbox__input" [(ngModel)]="isCheck" name="checkAll" id="checkAll"
            (ngModelChange)="checkAll($event)">
          <div class="checkbox__data">
            <div class="checkbox__indicator"></div>
            <p class="checkbox__text"></p>
          </div>
        </label>
      </div>

      <div class="column col-md-3 col-sm-3">
        <i class="fa fa-file-o mr-2"></i>
        <span>Name</span>
      </div>
      <div class="column col-md-2 col-sm-2">
        <span>Modified</span>
      </div>

      <div class="column col-md-2 col-sm-2">
        <span>Size</span>
      </div>
      <div class="column col-md-2 col-sm-2 justify-content-center">
        <span>Uploaded By</span>
      </div>

      <div class="column col-md-2 col-sm-2">
        <span>Document Type</span>
      </div>
      <div class="column col">
      </div>


    </div>

    <div class="result-field" *ngFor="let item of reportFiles; let x = index;">
      <div class="column check mr-3">
        <label class="checkbox mb-0">
          <input type="checkbox" class="checkbox__input" [(ngModel)]="item.SELECTED" name="selected_{{x}}"
            id="selected_{{x}}" (ngModelChange)="onCheckedFile($event, item)">
          <div class="checkbox__data">
            <div class="checkbox__indicator"></div>
            <p class="checkbox__text"></p>
          </div>
        </label>
      </div>

      <div class="column col-md-3 col-sm-3" (click)="openFolder(item)">
        <i class="fa mr-2"
          [ngClass]="{'fa-folder': item.TYPE == ReportFileType.FOLDER,
            'fa-file-excel-o': item.TYPE == ReportFileType.FILE && (getFileExtension(item.NAME) == ExtenstiionType.xlsx || getFileExtension(item.NAME) == ExtenstiionType.xls),
            'fa-file-pdf-o': item.TYPE == ReportFileType.FILE && getFileExtension(item.NAME) == ExtenstiionType.pdf,
            'fa-file-word-o': item.TYPE == ReportFileType.FILE && (getFileExtension(item.NAME) == ExtenstiionType.docx || getFileExtension(item.NAME) == ExtenstiionType.doc),
            'fa-file-archive-o': item.TYPE == ReportFileType.FILE && (getFileExtension(item.NAME) == ExtenstiionType.rar || getFileExtension(item.NAME) == ExtenstiionType.zip),
            'fa-file-text-o': item.TYPE == ReportFileType.FILE && getFileExtension(item.NAME) == ExtenstiionType.txt}"></i>
        <span class="item_name" [popover]="item.TYPE == ReportFileType.FOLDER?'' :'Click on the document for preview'" triggers="mouseenter:mouseleave" (click)="onPreview(item)">{{item.NAME}}</span>
      </div>

      <div class="column col-sm-2 col-md-2" (click)="openFolder(item)">
        <span>{{item.UPLOADED_DATE | amTimeAgo}}</span>
      </div>

      <div class="column col-sm-2 col-md-2" (click)="openFolder(item)">
        <span>{{item.SIZE | filesize }}</span>
      </div>
      <div class="column col-sm-2 col-md-2 justify-content-center" (click)="openFolder(item)">
         <custom-avatar *ngIf="item.UPLOADED_BY"  [id]="item?.UPLOADED_BY?.ID" [url]="item?.UPLOADED_BY?.AVATAR_URL" 
              [name]="item.UPLOADED_BY?.getName()"
          [color]="item?.UPLOADED_BY?.AVATAR_COLOR" size="32"></custom-avatar> 
      </div>
      <div class="column col-sm-2 col-md-2" (click)="openFolder(item)">
        <span>{{getDocumentName(item.DOCUMENT_TYPE)}} </span>
      </div>
     
      <div class="column col">
        <div class="watch btn-rbv-dropdown hinted text-right" dropdown>
          <button dropdownToggle type="button" class="btn top-nav-button">
            <fa class="check-block" name="fa fa-ellipsis-v"></fa>
          </button>

          <div *dropdownMenu class="drop-menu dropdown-menu-right rounded-0 width-200">


            <a class="drop-item" (click)="downloadFile(item)">
              <div class="item" >Download </div>
            </a>

            <a class="drop-item" (click)="rename(item)">
              <div class="item">Rename </div>
            </a>

            <a class="drop-item" (click)="changeType(item)">
              <div class="item">Change Document Type </div>
            </a>


            <a class="drop-item" (click)="delete(item)">
              <div class="item"  style="color: red;">Delete</div>
            </a>
          </div>
        </div>
      </div>


    </div>
  </div>


</ng-template>

